var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTool1Rectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_20099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4849 10.5151H10.5049V13.4951H13.4849V10.5151Z",
    fill: "current",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4949 10.5151H26.5149V13.4951H29.4949V10.5151Z",
    fill: "current",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4849 26.5054H10.5049V29.4854H13.4849V26.5054Z",
    fill: "current",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4949 26.5054H26.5149V29.4854H29.4949V26.5054Z",
    fill: "current",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9949 26.505V13.835",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5149 27.9951H13.4849",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0049 13.835V26.505",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4849 12.0054H26.5149",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_20099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.99,
    height: 19.97,
    fill: "current",
    transform: "translate(10.0049 10.0151)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool1Rectangle);
export default __webpack_public_path__ + "static/media/tool1_rectangle.7c5f74d8bc436429037f93ffa539d8a3.svg";
export { ForwardRef as ReactComponent };